<section
  class="glass-fog"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-intensity-input]="intensity"
  [style.--scene-speed-input]="speed"
>
  <div class="fog-backdrop"></div>

  <span
    *ngFor="let blob of blobs"
    class="fog-blob"
    [style.left]="blob.left"
    [style.top]="blob.top"
    [style.width]="blob.size"
    [style.height]="blob.size"
    [style.animation-delay]="blob.delay"
    [style.animation-duration]="blob.duration"
  ></span>

  <div class="fog-sheen"></div>
</section>
